import { Component, OnInit, Input } from '@angular/core';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { UnidadResponsable } from 'src/app/models/entities/unidad-responsable';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { take } from 'rxjs/operators';
import { PresupuestoEstado } from 'src/app/models/entities/presupuesto-estado';

@Component({
  selector: 'seguimiento-pef',
  templateUrl: './seguimiento-pef.component.html',
  styleUrls: ['./seguimiento-pef.component.scss']
})
export class SeguimientoPefComponent implements OnInit {

  @Input('datosSeguimientoPEF')
  public datosSeguimientoPEF: any;

  @Input('reporteCompleto')
  public reporteCompleto: any[];

  public meses: string[] = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];
  public fechaActual: Date = new Date();
  public anioActual: number;
  public mesActual: number;

  public catUnidadesResponsables: UnidadResponsable[] = [];

  constructor(private catalogoService: CatalogoService) { }

  async ngOnInit() {
    await this.obtenerCatalogos();
    this.anioActual = this.fechaActual.getUTCFullYear();
    this.mesActual = this.fechaActual.getUTCMonth();
  }

  public async obtenerCatalogos(): Promise<any> {
    this.catUnidadesResponsables = await this.catalogoService.obtenerCatalogo<UnidadResponsable>(RutaCatalogoEnum.UNIDADES_RESPONSABLES).pipe(take(1)).toPromise();
  }

  public obtenerNombreEstado(keyUR: string): string {
    return this.catUnidadesResponsables.find((ur: any) => ur.cve == keyUR).nombreEstado.toUpperCase();
  }

}
